import React, { useState } from "react";
import { motion } from "framer-motion";
import "./how.scss";
import Joinmodal from "../modals/Joinmodal";

const How = () => {
  const [modals, setModals] = useState({
    join: false,
    register: false,
  });

  const closeModal = (name) =>
    setModals((prev) => ({ ...prev, [name]: false }));

  const fadeUp = {
    hidden: { opacity: 0, y: 50, filter: "blur(4px)" },
    show: {
      opacity: 1,
      y: 0, 
      filter: "blur(0px)",
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }
    },
  };

  const leftAnim = {
    hidden: { opacity: 0, x: -80, filter: "blur(4px)" },
    show: { opacity: 1, x: 0, filter: "blur(0px)", transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] } },
  };

  const rightAnim = {
    hidden: { opacity: 0, x: 80, filter: "blur(4px)" },
    show: { opacity: 1, x: 0, filter: "blur(0px)", transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] } },
  };

  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.2, delayChildren: 0.1 } },
  };

  return (
    <>
      <section className="how" id="how-it-works">
        <img src="/assets/how/howmainimg.png" alt="img" className="howimage" />
        <div className="custom-container">
          <div className="parenthow">
            <motion.div
              className="left"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.25 }}
            >
              <span>How It Works</span>
              <h2>How TRAQSTOCK Works</h2>
              <p>
                TraqStock connects verified company data, transparent trading
                activity, and identity-verified investor discussions to create a
                more transparent environment for public markets.
              </p>
              <button onClick={()=>{
                window.location.href = "https://app.traqstock.com";
              }} className="join">Join as Investor</button>
            </motion.div>
            <motion.div
              className="right"
              variants={container}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.25 }}
            >
              <div className="parentbox">
                <motion.div className="innerbox" variants={leftAnim}>
                     <h2>01</h2>
                  <span className="cardshade"></span>
                  <div className="topcontent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M33.3272 14.7033C31.4785 7.33865 24.0097 2.86711 16.6451 4.71581C10.8898 6.16057 6.71076 11.1348 6.28018 17.053C2.19368 17.7269 -0.572818 21.5859 0.101093 25.6724C0.700168 29.3054 3.8481 31.966 7.53005 31.9513H13.7794V29.4516H7.53005C4.76894 29.4516 2.53059 27.2133 2.53059 24.4522C2.53059 21.6911 4.76894 19.4527 7.53005 19.4527C8.22036 19.4527 8.77991 18.8932 8.77991 18.2028C8.77366 11.9903 13.8049 6.949 20.0174 6.94283C25.3953 6.93744 30.0247 10.7394 31.065 16.0156C31.1677 16.5424 31.5952 16.9449 32.1274 17.0155C35.5443 17.5021 37.9198 20.6665 37.4333 24.0834C36.9964 27.1516 34.3766 29.4362 31.2774 29.4516H26.278V31.9513H31.2774C36.1094 31.9367 40.0146 28.0078 39.9999 23.1758C39.9877 19.1536 37.2346 15.6578 33.3272 14.7033Z"
                        fill="#0F172A"
                      />
                      <path
                        d="M19.1411 19.8151L14.1416 24.8146L15.9039 26.5769L18.7786 23.7147V35.7009H21.2783V23.7147L24.1405 26.5769L25.9028 24.8146L20.9034 19.8151C20.4158 19.3305 19.6286 19.3305 19.1411 19.8151Z"
                        fill="#0F172A"
                      />
                    </svg>
                  </div>
                  <div className="bottomcontent">
                    <h3>Companies Publish Verified Data</h3>
                    <p>
                      Public companies and transfer agents submit official share
                      structure information including authorized shares,
                      outstanding shares, and verified float data.
                    </p>
                  </div>
                </motion.div>
                <motion.div className="innerbox" variants={rightAnim}>
                    <h2>02</h2>
                  <span className="cardshade"></span>
                  <div className="topcontent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M36.9912 10.853L36.9899 10.8219C36.9725 10.4377 36.9609 10.0312 36.9539 9.57891C36.9213 7.37341 35.168 5.54907 32.9622 5.42578C28.3633 5.16913 24.8055 3.6695 21.7657 0.706556L21.7397 0.681837C20.7482 -0.227279 19.2526 -0.227279 18.2607 0.681837L18.2348 0.706556C15.195 3.6695 11.6372 5.16913 7.03824 5.42609C4.83274 5.54907 3.07921 7.37341 3.04656 9.57921C3.03984 10.0284 3.02794 10.4349 3.01054 10.8219L3.00871 10.8942C2.9193 15.5838 2.80821 21.4203 4.76072 26.7178C5.83433 29.631 7.4603 32.1634 9.59317 34.245C12.0224 36.6156 15.2041 38.4976 19.0499 39.8385C19.175 39.8822 19.3051 39.9176 19.4375 39.9441C19.6243 39.9813 19.8123 40 20.0002 40C20.1882 40 20.3765 39.9813 20.563 39.9441C20.6954 39.9176 20.8264 39.8819 20.9521 39.8379C24.7933 38.4945 27.9717 36.6116 30.3988 34.2413C32.5307 32.1591 34.1567 29.6262 35.2312 26.7123C37.1911 21.3989 37.0803 15.5515 36.9912 10.853ZM33.0291 25.9003C30.9698 31.4838 26.766 35.3183 20.1775 37.6223C20.1541 37.6303 20.129 37.6373 20.1031 37.6425C20.035 37.6559 19.9658 37.6559 19.8968 37.6422C19.8712 37.637 19.8461 37.6303 19.8229 37.6223C13.2275 35.3225 9.02096 31.4902 6.96317 25.9064C5.16355 21.0233 5.26548 15.6656 5.35551 10.9391L5.35612 10.9128C5.37443 10.5066 5.38664 10.0812 5.39335 9.6137C5.408 8.63439 6.18803 7.82415 7.16916 7.76953C9.77169 7.62426 12.0581 7.12133 14.1589 6.23205C16.257 5.34399 18.1204 4.09217 19.855 2.40516C19.9432 2.3307 20.0576 2.33039 20.1455 2.40516C21.8804 4.09217 23.7438 5.34399 25.8416 6.23205C27.9424 7.12133 30.2288 7.62426 32.8316 7.76953C33.8128 7.82415 34.5928 8.63439 34.6071 9.614C34.6142 10.084 34.6264 10.5094 34.6447 10.9128C34.7344 15.6449 34.8339 21.0068 33.0291 25.9003Z"
                        fill="#0F172A"
                      />
                      <path
                        d="M19.9998 10.032C14.503 10.032 10.0312 14.504 10.0312 20.0005C10.0312 25.4973 14.503 29.9694 19.9998 29.9694C25.4963 29.9694 29.9683 25.4973 29.9683 20.0005C29.9683 14.504 25.4963 10.032 19.9998 10.032ZM19.9998 27.622C15.7972 27.622 12.3784 24.2031 12.3784 20.0005C12.3784 15.798 15.7972 12.3791 19.9998 12.3791C24.202 12.3791 27.6209 15.798 27.6209 20.0005C27.6209 24.2031 24.202 27.622 19.9998 27.622Z"
                        fill="#0F172A"
                      />
                      <path
                        d="M22.8648 16.9058L18.2347 21.5359L16.978 20.2792C16.5196 19.8208 15.7765 19.8208 15.3182 20.2792C14.8601 20.7376 14.8601 21.4807 15.3182 21.9387L17.4049 24.0255C17.6341 24.2547 17.9344 24.3691 18.2347 24.3691C18.535 24.3691 18.8353 24.2547 19.0645 24.0255L24.5247 18.5653C24.9827 18.1069 24.9827 17.3638 24.5247 16.9058C24.0663 16.4471 23.3232 16.4471 22.8648 16.9058Z"
                        fill="#0F172A"
                      />
                    </svg>
                  </div>
                  <div className="bottomcontent">
                    <h3>Data is Verified</h3>
                    <p>
                      Submitted datasets are reviewed and verified before
                      publication to ensure accuracy, transparency, and data
                      integrity.
                    </p>
                  </div>
                </motion.div>
                <motion.div className="innerbox" variants={leftAnim}>
                     <h2>03</h2>
                  <span className="cardshade"></span>
                  <div className="topcontent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M20.0004 0L2.67969 9.99998V29.9999L20.0004 39.9999L37.3207 29.9999V9.99998L20.0004 0ZM33.8045 10.6764L20.0004 18.6429L6.19589 10.6764L20.0004 2.70647L33.8045 10.6764ZM5.02356 12.706L18.8284 20.6727V36.6169L5.02356 28.6467V12.706ZM21.1723 36.6169V20.6727L34.9768 12.7061V28.6467L21.1723 36.6169Z"
                        fill="#0F172A"
                      />
                    </svg>
                  </div>
                  <div className="bottomcontent">
                    <h3>Blockchain Anchoring</h3>
                    <p>
                      Verified datasets are permanently recorded to the
                      blockchain, creating timestamped records that cannot be
                      altered and can be independently verified.
                    </p>
                  </div>
                </motion.div>
                <motion.div className="innerbox" variants={rightAnim}>
                         <h2>04</h2>
                  <span className="cardshade"></span>
                  <div className="topcontent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_411_877)">
                        <path
                          d="M37.5041 28.886C41.3694 23.4628 40.7785 16.0327 35.499 11.1928C33.0867 8.98148 30.0115 7.60484 26.6895 7.22039C26.6688 7.19492 26.6477 7.16969 26.6245 7.14555C23.7345 4.14359 19.5827 2.42188 15.2334 2.42188C6.95695 2.42188 0 8.58852 0 16.4844C0 19.2527 0.859922 21.9066 2.49344 24.1985L0.211484 31.363C0.0680469 31.8134 0.209141 32.3056 0.569219 32.6116C0.929922 32.9182 1.43875 32.9771 1.85914 32.7633L8.79875 29.2346C10.2239 29.8483 11.7352 30.2509 13.3002 30.4341C16.3191 33.6088 20.4934 35.2344 24.7641 35.2344C26.9841 35.2344 29.196 34.782 31.1984 33.922L38.1384 37.4509C38.3064 37.5363 38.4884 37.5781 38.6692 37.5781C39.4601 37.5781 40.027 36.8074 39.786 36.0505L37.5041 28.886ZM9.27172 26.8766C8.94352 26.7208 8.56172 26.7259 8.23789 26.8906L3.29516 29.4039L4.90922 24.3363C5.02672 23.9673 4.95445 23.5641 4.71602 23.2591C3.16398 21.2723 2.34359 18.9298 2.34359 16.4844C2.34359 10.0227 8.12594 4.76562 15.2334 4.76562C18.0956 4.76562 20.851 5.63273 23.0861 7.19422C15.5589 7.95109 9.53062 13.8303 9.53062 21.1719C9.53062 23.4553 10.1159 25.6536 11.2195 27.6231C10.5513 27.4241 9.90063 27.1753 9.27172 26.8766ZM31.7596 31.578C31.4405 31.4158 31.0584 31.406 30.7258 31.5641C28.8988 32.432 26.8373 32.8906 24.7641 32.8906C17.6566 32.8906 11.8742 27.6336 11.8742 21.1719C11.8742 14.7102 17.6566 9.45312 24.7641 9.45312C31.8716 9.45312 37.6539 14.7102 37.6539 21.1719C37.6539 23.6173 36.8335 25.9598 35.2814 27.9465C35.043 28.2516 34.9708 28.6547 35.0882 29.0237L36.7023 34.0913L31.7596 31.578Z"
                          fill="#0F172A"
                        />
                        <path
                          d="M19.9985 22.3438C20.6457 22.3438 21.1704 21.8191 21.1704 21.1719C21.1704 20.5247 20.6457 20 19.9985 20C19.3513 20 18.8267 20.5247 18.8267 21.1719C18.8267 21.8191 19.3513 22.3438 19.9985 22.3438Z"
                          fill="#0F172A"
                        />
                        <path
                          d="M24.686 22.3438C25.3332 22.3438 25.8579 21.8191 25.8579 21.1719C25.8579 20.5247 25.3332 20 24.686 20C24.0388 20 23.5142 20.5247 23.5142 21.1719C23.5142 21.8191 24.0388 22.3438 24.686 22.3438Z"
                          fill="#0F172A"
                        />
                        <path
                          d="M29.373 22.3438C30.0203 22.3438 30.5449 21.8191 30.5449 21.1719C30.5449 20.5247 30.0203 20 29.373 20C28.7258 20 28.2012 20.5247 28.2012 21.1719C28.2012 21.8191 28.7258 22.3438 29.373 22.3438Z"
                          fill="#0F172A"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_411_877">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="bottomcontent">
                    <h3>Investors Access Transparent Insights</h3>
                    <p>
                      Investors can view verified company data, transparent
                      trading activity, and participate in identity-verified
                      discussions for each ticker.
                    </p>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Joinmodal show={modals.join} onHide={() => closeModal("join")} />
    </>
  );
};

export default How;
